
import Vue from "vue";
import AppMonthSelect from "@/components/common/MonthSelect.vue";
import { BookkeepingService } from "@/services";

export default Vue.extend({
	data(){
		let date = new Date();
		return {
			month: date.getMonth()+1,
			year: date.getFullYear(),
			creating: false
		};
	},
	computed: {
		disabled():boolean{
			return this.creating;
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async create(){
			if (this.creating) return;
			this.creating = true;
			try{
				await BookkeepingService.createIntrastat(this.month, this.year);
				this.$emit("close");
			}catch(err){

			}finally{
				this.creating = false;
			}
		},
	},
	components: {
		AppMonthSelect
	},
	i18nEx: {
		componentPrefix: "components.bookkeeping"
	}
});
